import { randomUUID } from '@/utils/util'

const excludeKeywords = [
  'FirmwareInformationForm',
  'HardwareInformationForm',
  'SoftwareInformationForm',
  'StructuralInformationForm',
  'ProcessFileInformationForm',
  'SchemeChangeForm'
]
/**
 * 提交审批格式化formData
 * @param {*} formData 表单数据
 * @param {*} key 字段key
 * @param {*} forms 表单组件定义
 * @returns {string} 格式化后的值
 */
export function formateValue(
  formData,
  key,
  forms = [],
  filterOriginBizAlias = []
) {
  try {
    // 1. 空值处理
    if (!formData || !key) {
      return ''
    }

    const value = formData[key]
    // 2. 非对象类型直接返回
    if (typeof value !== 'object' || value === null) {
      return value
    }

    // 3. 根据不同字段类型处理
    const fieldType = getFieldType(key)
    switch (fieldType) {
      case 'InnerContactField':
      case 'DepartmentField':
        return formatContactField(value)

      // case 'DDAttachment':
      // case 'DDPhotoField':
      //   return formatAttachmentField(value)

      case 'DDMultiSelectField':
      case 'DDDateRangeField':
      case 'StandardCircuitField':
        return formatArrayField(value)

      case 'TableField':
        return formatTableField(value, key, forms, filterOriginBizAlias)
      case 'SvnAssociatedFileField':
        return formatSvnAssociatedFileField(value)
      default:
        return Array.isArray(value) ? value.join() : value
    }
  } catch (error) {
    console.error('Format value error:', error)
    return ''
  }
}
function formatSvnAssociatedFileField(value) {
  const files = Array.isArray(value) ? value : []
  const rootSvnUrl = (files[0] && files[0].rootSvnUrl) || ''
  return rootSvnUrl
}
/**
 * 获取字段类型
 * @param {string} key
 * @returns {string}
 */
function getFieldType(key) {
  const types = [
    'InnerContactField',
    'DepartmentField',
    // 'DDAttachment',
    'DDPhotoField',
    'DDMultiSelectField',
    'DDDateRangeField',
    'StandardCircuitField',
    'TableField',
    'SvnAssociatedFileField'
  ]

  return types.find((type) => key.includes(type)) || ''
}

/**
 * 格式化联系人/部门字段
 * @param {Array} value
 * @returns {string}
 */
function formatContactField(value) {
  return Array.isArray(value)
    ? value
        .map((v) => v.name)
        .filter(Boolean)
        .join()
    : ''
}

/**
 * 格式化附件字段
 * @param {Array} value
 * @returns {string}
 */
function formatAttachmentField(value) {
  return Array.isArray(value)
    ? value
        .map((v) => v.title)
        .filter(Boolean)
        .join()
    : ''
}

/**
 * 格式化数组类型字段
 * @param {Array} value
 * @returns {Array}
 */
function formatArrayField(value) {
  return Array.isArray(value) ? value.join() : ''
}

/**
 * 格式化表格字段
 * @param {Array} value 表格数据
 * @param {string} key 字段key
 * @param {Array} forms 表单定义
 * @returns {string}
 */
function formatTableField(value, key, forms, filterOriginBizAlias) {
  if (!Array.isArray(value) || !Array.isArray(forms)) {
    return ''
  }

  // 获取所有TableField组件
  const tableFields = forms.filter((form) => form.name === 'TableField')

  // 根据key找到对应的TableField组件
  const currentTableField = tableFields.find(
    (field) => (field.props && field.props.componentId === key) || field.id === key
  )

  if (!currentTableField) {
    return ''
  }

  const tableFieldChildren = (currentTableField.props && currentTableField.props.children) || []
  const childIdSet = new Set(
    Array.isArray(tableFieldChildren) ? tableFieldChildren.map((child) => child.id) : []
  )

  const findOriginField = (rowKey) =>
    Array.isArray(filterOriginBizAlias)
      ? filterOriginBizAlias.find((form) => form.id === rowKey)
      : null

  const buildRowCell = (rowKey, column, cellValue) => {
    const originField = findOriginField(rowKey)
    return {
      key: rowKey,
      value: formatTableCellValue(rowKey, cellValue),
      label:
        (column && column.title) ||
        (originField && originField.title) ||
        rowKey,
      bizAlias:
        (column && column.bizAlias) ||
        (originField && originField.bizAlias) ||
        undefined
    }
  }

  // 格式化表格数据
  const formattedValue = value.map((row) => {
    const normalizedRow = (row && typeof row === 'object') ? row : {}
    const rowValue = Array.isArray(tableFieldChildren) && tableFieldChildren.length
      ? tableFieldChildren.map((column) =>
          buildRowCell(column.id, column, normalizedRow[column.id])
        )
      : Object.entries(normalizedRow).map(([rowKey, cellValue]) =>
          buildRowCell(rowKey, null, cellValue)
        )

    if (tableFieldChildren.length) {
      Object.entries(normalizedRow).forEach(([rowKey, cellValue]) => {
        if (!childIdSet.has(rowKey)) {
          rowValue.push(buildRowCell(rowKey, null, cellValue))
        }
      })
    }

    return {
      rowNumber: `${currentTableField.id || key}_${randomUUID()}`,
      rowValue
    }
  })

  return JSON.stringify(formattedValue)
}

/**
 * 格式化表格单元格值
 * @param {string} key 列key
 * @param {any} value 单元格值
 * @returns {string}
 */
function formatTableCellValue(key, value) {
  if (!value) return ''

  if (key.includes('StandardCircuitField')) {
    return Array.isArray(value) ? value.join() : value
  }

  if (typeof value === 'object') {
    return JSON.stringify(value)
  }

  return value.toString()
}

/**
 * 根据数据组件类型回填表单
 * @param {*} item
 * @returns
 */
export function setFormValue(item) {
  const [componentType] = (item.id && item.id.split('_')) || []
  if (componentType === 'NumberField') {
    return item.value == '' ? null : Number(item.value)
  } else if (
    [
      'DDMultiSelectField',
      'DDDateRangeField',
      'InnerContactField',
      'DepartmentField',
      // 'DDAttachment',
      'DDPhotoField',
      'TableField',
      'StandardCircuitField',
      'OaProcessField'
    ].includes(componentType)
  ) {
    return item.extValue ? JSON.parse(item.extValue) : []
  } else {
    return item.value
  }
}

/**
 * 拆解参数
 * @param {*} item
 * @returns
 */
export function splitPropsParams(item, type = 0) {
  let splitParams = {
    name: item.componentType,
    title: item.name || item.props.label,
    icon: item.props.icon,
    id: item.id || item.props.componentId,
    componentId: item.id || item.props.componentId,
    bizAlias: item.props.bizAlias,
    format: item.props.format, // 日期格式
    unit: item.props.unit, // 单位
    value: type ? item.value : item.props.value,
    valueType: item.props.valueType,
    perm: item.perm, // 表单权限
    conditionRequired: item.props.conditionRequired,
    defaultValue: item.props.defaultValue
  }

  return splitParams
}
/**
 * 平铺过滤字段
 * @param {*} formData
 * @returns
 */
export function flattenAndFilterFields(items) {
  const result = []

  const processItem = (item) => {
    // 如果有bizAlias属性且值不为空，添加到结果数组
    if (item.bizAlias) {
      result.push(item)
    }

    // 处理直接children
    if (item.children && item.children.length > 0) {
      item.children.forEach((child) => processItem(child))
    }

    // 处理props.children (如果存在)
    if (item.props && item.props.children && item.props.children.length > 0) {
      item.props.children.forEach((child) => processItem(child))
    }
  }

  // 处理每个顶级项
  if (items && Array.isArray(items)) {
    items.forEach((item) => processItem(item))
  }

  return result
}
/**
 * 处理表单数据
 * @param {*} formData
 * @returns
 */
export function processFormData(formData, type = '') {
  // 确保 formData 是一个数组
  if (!Array.isArray(formData)) {
    // console.log('Invalid formData: Expected an array.')
    return []
  }

  return formData.reduce((acc, item) => {
    if (type === 'origin') {
      if (
        [
          'TableField',
          'SpanLayoutField',
          'OrderReviewForm',
          'ProjectInfoForm',
          'ProjectCostDataForm',
          'FirmwarePartNumberReferenceForm',
          'FirmwarePartNumberCreateForm',
          'MeterTypeForm',
          'MaterialForm',
          'ADMaterialGroupForm',
          'ProjectCostDataForm'
        ].concat(excludeKeywords).includes(item.name) &&
        Array.isArray(item.props && item.props.children)
      ) {
        // 直接将子组件展开并添加到结果数组中
        acc.push(...item.props.children)
      } else {
        // 仅添加非 SpanLayoutField 类型的项
        acc.push(item)
      }
    } else if (type === 'condition') {
      if (
        item.componentId &&
        (item.componentId.includes('SpanLayoutField') ||
          item.componentId.includes('OrderReviewForm') ||
          item.componentId.includes('ProjectInfoForm') ||
          item.componentId.includes('ProjectCostDataForm') ||
          item.componentId.includes('FirmwarePartNumberReferenceForm') ||
          item.componentId.includes('FirmwarePartNumberCreateForm') ||
          item.componentId.includes('MeterTypeForm') ||
          item.componentId.includes('MaterialForm') ||
          item.componentId.includes('ADMaterialGroupForm')) &&
        Array.isArray(item.props && item.props.children)
      ) {
        acc.push(...(item.props && item.props.children))
      } else {
        acc.push(item)
      }
    } else {
      if (
        [
          'SpanLayoutField',
          'OrderReviewForm',
          'ProjectInfoForm',
          'ProjectCostDataForm',
          'MeterTypeForm',
          'MaterialForm',
          'ADMaterialGroupForm',
          'TableField',
          'FirmwarePartNumberReferenceForm',
          'FirmwarePartNumberCreateForm'
        ].concat(excludeKeywords).includes(item.componentType) &&
        Array.isArray(item.children)
      ) {
        acc.push(...item.children)
      } else {
        acc.push(item)
      }
    }
    return acc
  }, [])
}
/**
 * 处理流程节点
 * @param {*} node
 * @param {*} enableConditionBranch 是否开启条件分支结构处理
 * @returns
 */
export function flattenTree(node, enableConditionBranch = true) {
  // 创建一个数组来存储平铺后的结果
  const result = []

  // 辅助函数，用于递归遍历树结构
  function traverse(currentNode, parentBranchId = null) {
    // 检查当前节点的 id 是否为 undefined
    if (!currentNode || currentNode.id === undefined) {
      return
    }

    const { id, parentId, type, name, desc, props, branchs, children } =
      currentNode
    const nodeData = {
      id,
      parentId,
      type,
      name,
      desc,
      props,
      branchId: parentBranchId
    }

    // 如果开启条件分支结构处理且是CONDITIONS类型
    if (
      enableConditionBranch &&
      type === 'CONDITIONS' &&
      Array.isArray(branchs)
    ) {
      // 添加条件节点本身
      result.push(nodeData)

      // 遍历所有分支
      branchs.forEach((branch, index) => {
        const branchId = `${id}_branch_${index}`

        // 添加分支节点
        result.push({
          id: branchId,
          parentId: id,
          type: 'BRANCH',
          name: branch.name || `分支${index + 1}`,
          desc: branch.desc,
          props: branch.props,
          conditionDesc: branch.conditionDesc
        })

        // 处理分支内的节点
        if (branch.children) {
          traverse(branch.children, branchId)
        }
      })

      // 处理条件节点之后的子节点
      if (children) {
        traverse(children, parentBranchId)
      }
    } else if (type === 'EMPTY') {
      // 对于 EMPTY 类型节点，直接处理其子节点
      if (children) {
        traverse(children, parentBranchId)
      }
    } else {
      // 非条件节点或未开启条件分支处理时，直接添加节点
      result.push(nodeData)

      // 继续遍历子节点
      if (children) {
        traverse(children, parentBranchId)
      }
    }
  }

  // 开始遍历传入的根节点
  traverse(node)
  return result
}
/**
 * 耗时计算
 * @param {*} applyTime
 * @param {*} finishTime
 * @returns
 */
export function computedTimeSpent(applyTime, finishTime) {
  if (applyTime) {
    const applyTimeStamp = new Date(applyTime).getTime()
    const finishTimeStamp = finishTime
      ? new Date(finishTime).getTime()
      : new Date().getTime()
    const diffTime = (finishTimeStamp - applyTimeStamp) / 1000
    if (diffTime > 0) {
      let d = Math.floor(diffTime / (3600 * 24))
      let h = Math.floor((diffTime / 3600) % 24)
      let m = Math.floor((diffTime / 60) % 60)
      let s = Math.floor(diffTime % 60)
      if (d !== 0) {
        return `${d}天 ${h}小时 ${m}分钟 ${s}秒`
      } else if (h !== 0) {
        return `${h}小时 ${m}分钟 ${s}秒`
      } else if (m !== 0) {
        return `${m}分钟 ${s}秒`
      } else {
        return `${s}秒`
      }
    } else {
      return '0'
    }
  } else {
    return '--'
  }
}

/**
 * 扁平化 SpanLayoutField
 * @param {*} components
 * @param {*} data
 * @returns
 */
export const flattenSpanLayoutFields = (components, data) => {
  const result = []

  // 递归处理子组件的函数
  const processChildren = (children) => {
    if (!children || !children.length) return

    children.forEach((child) => {
      // 检查是否是MaterialForm等特殊组件
      if (
        ['MaterialForm', 'OrderReviewForm', 'ProjectInfoForm', 'ProjectCostDataForm', 'MeterTypeForm', 'ADMaterialGroupForm', 'FirmwarePartNumberReferenceForm', 'FirmwarePartNumberCreateForm'].concat(excludeKeywords).includes(
          child.componentType
        )
      ) {
        // 先添加组件本身
        const childData = data.find((v) => v.id === child.props.componentId)
        if (childData) {
          result.push({
            ...child,
            ...childData,
            id: child.props.componentId,
            name: child.props.label || child.props.componentType
          })

          // 处理MaterialForm的子组件
          if (child.children && child.children.length) {
            processChildren(child.children)
          }
        }
      } else {
        // 普通子组件
        const childData = data.find((v) => v.id === child.props.componentId)
        if (childData) {
          result.push({ ...child, ...childData })
        }
      }
    })
  }

  components.forEach((item) => {
    // 处理特殊布局组件
    if (
      [
        'SpanLayoutField',
        'OrderReviewForm',
        'ProjectInfoForm',
        'ProjectCostDataForm',
        'MeterTypeForm',
        'MaterialForm',
        'ADMaterialGroupForm',
        'FirmwarePartNumberReferenceForm',
        'FirmwarePartNumberCreateForm'
      ].concat(excludeKeywords).includes(item.componentType)
    ) {
      // 将布局组件本身添加到结果
      result.push({
        ...item,
        id: item.props.componentId,
        name: item.props.label || item.componentType,
        children: [], // 清空children，因为我们会将其平铺
        span: item.componentType === 'SpanLayoutField' ? 2 : 1
      })

      // 如果有children，递归处理
      if (item.children && item.children.length) {
        processChildren(item.children)
      }
    } else {
      // 处理普通组件
      const itemData = data.find((v) => v.id === item.props.componentId)
      if (itemData) {
        result.push({ ...item, ...itemData })
      }
    }
  })

  return result
}

/**
 * 提取控件组中 showFields 指定的字段数据
 * @param {Array} components 表单组件数据
 * @returns {Array} 提取的字段数据
 */
export const extractShowFields = (components) => {
  const result = []

  if (!Array.isArray(components)) {
    // console.log('Invalid components: Expected an array.')
    return result
  }

  components.forEach((component) => {
    // 检查是否是控件组类型（MeterTypeForm, MaterialForm, OrderReviewForm, ADMaterialGroupForm等）
    if (
      [
        'MeterTypeForm',
        'MaterialForm',
        'OrderReviewForm',
        'ProjectInfoForm',
        'ProjectCostDataForm',
        'ADMaterialGroupForm',
        'FirmwarePartNumberReferenceForm',
        'FirmwarePartNumberCreateForm'
      ].concat(excludeKeywords).includes(component.componentType)
    ) {
      const showFields = component.props && component.props.extendProps && component.props.extendProps.showFields

      // 如果存在 showFields 且为数组
      if (Array.isArray(showFields) && showFields.length > 0) {
        // 遍历 children 找到匹配的字段
        if (Array.isArray(component.children)) {
          showFields.forEach((fieldBizAlias) => {
            const matchedChild = component.children.find(
              (child) => child.props && child.props.bizAlias === fieldBizAlias
            )

            if (matchedChild) {
              result.push({
                ...matchedChild,
                // 添加父组件信息
                parentComponentType: component.componentType,
                parentComponentId: component.props && component.props.componentId,
                parentLabel: component.props && component.props.label,
                // 标记这是从 showFields 中提取的
                fromShowFields: true
              })
            }
          })
        }
      }
    }
  })

  return result
}

/**
 * 根据 showFields 过滤并重组控件组数据
 * @param {Array} components 表单组件数据
 * @returns {Array} 重组后的数据
 */
export const filterByShowFields = (components) => {
  const result = []

  if (!Array.isArray(components)) {
    // console.log('Invalid components: Expected an array.')
    return result
  }

  components.forEach((component) => {
    // 检查是否是控件组类型
    if (
      [
        'MeterTypeForm',
        'MaterialForm',
        'OrderReviewForm',
        'ProjectInfoForm',
        'ProjectCostDataForm',
        'ADMaterialGroupForm',
        'FirmwarePartNumberReferenceForm',
        'FirmwarePartNumberCreateForm'
      ].concat(excludeKeywords).includes(component.componentType)
    ) {
      const showFields = component.props && component.props.extendProps && component.props.extendProps.showFields

      // 如果存在 showFields，只保留指定的字段
      if (Array.isArray(showFields) && showFields.length > 0) {
        const filteredChildren = []

        // 按照 showFields 的顺序添加字段
        showFields.forEach((fieldBizAlias) => {
          const matchedChild = component.children && component.children.find(
            (child) => child.props && child.props.bizAlias === fieldBizAlias
          )

          if (matchedChild) {
            filteredChildren.push(matchedChild)
          }
        })

        // 创建新的组件对象，只包含 showFields 中的字段
        result.push({
          ...component,
          children: filteredChildren,
          // 添加标记表示已经过滤
          filteredByShowFields: true,
          originalChildrenCount: (component.children && component.children.length) || 0,
          showFieldsCount: filteredChildren.length
        })
      } else {
        // 如果没有 showFields，保持原样
        result.push(component)
      }
    } else {
      // 非控件组类型，直接添加
      result.push(component)
    }
  })

  return result
}

/**
 * 获取控件组的配置信息
 * @param {Array} components 表单组件数据
 * @returns {Array} 控件组配置信息
 */
export const getControlGroupConfigs = (components) => {
  const configs = []

  if (!Array.isArray(components)) {
    return configs
  }

  components.forEach((component) => {
    if (
      [
        'MeterTypeForm',
        'MaterialForm',
        'OrderReviewForm',
        'ProjectInfoForm',
        'ProjectCostDataForm',
        'ADMaterialGroupForm',
        'FirmwarePartNumberReferenceForm',
        'FirmwarePartNumberCreateForm'
      ].concat(excludeKeywords).includes(component.componentType)
    ) {
      const showFields = component.props && component.props.extendProps && component.props.extendProps.showFields

      configs.push({
        componentType: component.componentType,
        componentId: component.props && component.props.componentId,
        label: component.props && component.props.label,
        showFields: showFields || [],
        hasShowFields: Array.isArray(showFields) && showFields.length > 0,
        totalChildren: (component.children && component.children.length) || 0,
        showFieldsCount: Array.isArray(showFields) ? showFields.length : 0,
        hiddenFieldsCount: ((component.children && component.children.length) || 0) - (Array.isArray(showFields) ? showFields.length : 0)
      })
    }
  })

  return configs
}
